import(/* webpackMode: "eager" */ "/vercel/path0/sun/src/app/contact/page.tsx");
